import * as THREE from "three";

const LIGHT_MARKER_MESH_HEX = 0xffd166;
const LIGHT_MARKER_LINE_HEX = 0xff9f1c;

export function getSavedSceneLightPickUuid(obj) {
  let current = obj;
  while (current) {
    const ud = current.userData || {};
    if (ud.isSavedSceneLightMarker && ud.savedSceneLightUuid) {
      return String(ud.savedSceneLightUuid);
    }
    if (ud.savedSceneLightUuid) return String(ud.savedSceneLightUuid);
    current = current.parent;
  }
  return null;
}

export function createSavedLightMarker(lightDef) {
  const group = new THREE.Group();
  group.name = lightDef?.name || lightDef?.uuid || "saved-light";
  group.userData = {
    type: "light",
    lightUuid: lightDef?.uuid || null,
    lightName: lightDef?.name || null,
    savedSceneLightUuid: lightDef?.uuid || null,
  };

  const sphere = new THREE.Mesh(
    new THREE.SphereGeometry(0.045, 20, 16),
    new THREE.MeshBasicMaterial({
      color: LIGHT_MARKER_MESH_HEX,
      depthTest: false,
      depthWrite: false,
      transparent: true,
      opacity: lightDef?.active === false ? 0.35 : 0.95,
    })
  );
  sphere.name = "savedSceneLightMarkerMesh";
  sphere.renderOrder = 9997;
  sphere.userData = {
    isSavedSceneLightMarker: true,
    savedSceneLightUuid: lightDef?.uuid || null,
  };
  group.add(sphere);

  const pickSphere = new THREE.Mesh(
    new THREE.SphereGeometry(0.1, 12, 8),
    new THREE.MeshBasicMaterial({
      transparent: true,
      opacity: 0,
      depthTest: false,
      depthWrite: false,
    })
  );
  pickSphere.name = "savedSceneLightMarkerPickProxy";
  pickSphere.renderOrder = 9997;
  pickSphere.userData = {
    isSavedSceneLightMarker: true,
    savedSceneLightUuid: lightDef?.uuid || null,
  };
  group.add(pickSphere);

  const type = String(lightDef?.type || "spot").toLowerCase();
  const range = Math.max(0.2, Math.min(2, Number(lightDef?.range) || 1));
  const linePositions = [];
  linePositions.push(0, 0, 0, 0, 0, -Math.min(range, 0.45));
  if (type === "spot") {
    const length = Math.min(range, 0.45);
    const radius = Math.tan(THREE.MathUtils.degToRad(Number(lightDef?.cutoff) || 45)) * length;
    const r = Math.min(Math.max(radius, 0.04), 0.35);
    const z = -length;
    const corners = [
      [-r, -r, z],
      [r, -r, z],
      [r, r, z],
      [-r, r, z],
    ];
    corners.forEach((corner) => linePositions.push(0, 0, 0, ...corner));
    [
      [0, 1],
      [1, 2],
      [2, 3],
      [3, 0],
    ].forEach(([a, b]) => linePositions.push(...corners[a], ...corners[b]));
  }

  const geometry = new THREE.BufferGeometry();
  geometry.setAttribute("position", new THREE.Float32BufferAttribute(linePositions, 3));
  const rays = new THREE.LineSegments(
    geometry,
    new THREE.LineBasicMaterial({
      color: LIGHT_MARKER_LINE_HEX,
      depthTest: false,
      depthWrite: false,
      transparent: true,
      opacity: lightDef?.active === false ? 0.35 : 0.85,
    })
  );
  rays.renderOrder = 9997;
  rays.userData = {
    savedSceneLightUuid: lightDef?.uuid || null,
  };
  rays.raycast = () => {};
  group.add(rays);
  return group;
}
